var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('spaceHeader'),_c('div',{staticClass:"fixation"},[_c('div',{staticClass:"view"},[_c('router-view')],1)]),_c('pubfooter'),_c('floatButton',{attrs:{"current":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }